import {defineStore} from "pinia/dist/pinia";

export const useEndpointStore = defineStore('EndpointStore', {
    state() {
        return {
            endpointState: null,
            iamBackendEndpointState: null,
            exportEndpointState: null,
            ssoEndpointState: null,
            cofaceWebAssicuratiEndpointState: null,
        }

    },
    getters: {
        endpoint() { return this.endpointState },
        iamBackendEndpoint() { return this.iamBackendEndpointState },
        exportEndpoint() { return this.exportEndpointState },
        ssoEndpoint() { return this.ssoEndpointState },
        cofaceWebAssicuratiEndpoint() { return this.cofaceWebAssicuratiEndpointState },
    },
    actions: {
        setEndpoint(endpoint) { this.endpointState = endpoint },
        setIamBackendEndpoint(endpoint) { this.iamBackendEndpointState = endpoint },
        setExportEndpoint(endpoint) { this.exportEndpointState = endpoint },
        setSsoEndpoint(ssoEndpoint) { this.ssoEndpointState = ssoEndpoint },
        setCofaceWebAssicuratiEndpoint(cofaceWebAssicuratiEndpoint) { this.cofaceWebAssicuratiEndpointState = cofaceWebAssicuratiEndpoint },
    }
})